// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3zFC2","footer":"ModalError_footer__1kgPH"};